import React from "react";
import { getDsLayoutComponentRenderer } from "@kaltura/mediaspace-shared-layout";

const ManageSubsciption = React.lazy(() => import("@kaltura/mediaspace-shared-messaging-subscription"));

export const render = getDsLayoutComponentRenderer(ManageSubsciption);
